import { useEffect, useState } from 'preact/hooks';
import { InstallBanner } from './components/InstallBanner.tsx';
import { Modal } from './components/Modal.tsx';
import { Nav, type PageId } from './components/Nav.tsx';
import { Toast } from './components/Toast.tsx';
import { Topbar } from './components/Topbar.tsx';
import { AuthGate } from './auth/AuthGate.tsx';
import { SyncBadge } from './components/SyncBadge.tsx';
import { openQuickAdd } from './features/misc/QuickAdd.tsx';
import { AccountPage } from './pages/Account.tsx';
import { ClassPage } from './pages/Class.tsx';
import { FollowPage } from './pages/Follow.tsx';
import { HomePage } from './pages/Home.tsx';
import { MorePage } from './pages/More.tsx';
import { WeekPage } from './pages/Week.tsx';
import { LessonsPage } from './pages/Lessons.tsx';
import { TasksPage } from './pages/Tasks.tsx';
import { exportData } from './store/backup.ts';

function Journal() {
  const [page, setPage] = useState<PageId>('home');

  // Same behaviour as the original `go()`: switching page returns to the top.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [page]);

  return (
    <div class="app">
      <Topbar onQuickAdd={openQuickAdd} onExport={() => void exportData()} />

      <main>
        {page === 'home' && <HomePage onNavigate={setPage} />}
        {page === 'tasks' && <TasksPage onNavigate={setPage} />}
        {page === 'week' && <WeekPage />}
        {page === 'lessons' && <LessonsPage />}
        {page === 'class' && <ClassPage />}
        {page === 'follow' && <FollowPage />}
        {page === 'more' && <MorePage />}
        {page === 'account' && <AccountPage />}
      </main>

      <Nav current={page} onNavigate={setPage} />
      <SyncBadge />
    </div>
  );
}

export function App() {
  return (
    <>
      <AuthGate>
        <Journal />
      </AuthGate>

      <Modal />
      <Toast />
      <InstallBanner />
    </>
  );
}
